module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img01-a88b1a5c522609e0251c72796a35c1c8.png";